import { notification as AntdNotification } from "antd";

export default AntdNotification;
